export * from './featured-list.component';
